module.exports = __webpack_public_path__ + "static/media/1_r_golova_79.84_0.fc0a692c.png";